import { BaseNotificationContextEnum } from './base-notification-context.enum';

/**
 * Rental reservation notification context enum
 * @description Notification contexts specific to rental reservation subjects
 */
export enum RentalReservationNotificationContextEnum {
	// Base contexts
	INSERTED = BaseNotificationContextEnum.INSERTED,
	UPDATED = BaseNotificationContextEnum.UPDATED,
	DELETED = BaseNotificationContextEnum.DELETED,

	// Rental reservation-specific contexts
	PENDING = 'pending',
	ACCEPTED = 'accepted',
	REJECTED = 'rejected',
	CANCELLED = 'cancelled',
}
